import { ObserversModule } from '@angular/cdk/observers'
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { ReactiveFormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatDividerModule } from '@angular/material/divider'
import { MatIconModule } from '@angular/material/icon'
import { MatInputModule } from '@angular/material/input'
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner'
import { MatSelectModule } from '@angular/material/select'
import { TranslateModule } from '@ngx-translate/core'

import { CustomFieldModule } from '../custom-field'
import { SearchableSelectComponent } from './searchable-select.component'

@NgModule({
  imports: [
    CommonModule,
    ObserversModule,
    CustomFieldModule,
    MatButtonModule,
    MatDividerModule,
    MatIconModule,
    MatInputModule,
    MatSelectModule,
    MatProgressSpinnerModule,
    ReactiveFormsModule,
    TranslateModule,
  ],
  declarations: [SearchableSelectComponent],
  exports: [SearchableSelectComponent],
})
export class SearchableSelectModule { }
